import { LineChart } from '../../Common/Charts/LineChart';
import { usePacientProfileChartsDataContext } from './hooks/usePacientProfileChartsDataContext';

const SEX_COLORS = {
    Masculino: '#0D82D3',
    Feminino: '#D6588F',
    'Não informado': '#90A4AE'
};

export const PatientSexByYear = () => {
    const { chartData } = usePacientProfileChartsDataContext();

    const sexoPorAno = chartData?.sexByYear || {};
    const years = Object.keys(sexoPorAno).sort();

    const sexSet = new Set();
    years.forEach((year) => {
        Object.keys(sexoPorAno[year] || {}).forEach((sex) => sexSet.add(sex));
    });
    const sexes = Array.from(sexSet);

    const colors = sexes.map((sex) => SEX_COLORS[sex] || '#757575');
    const values = sexes.map((sex) => years.map((year) => sexoPorAno[year]?.[sex] ?? 0));

    return (
        <LineChart
            title={'Volume por Sexo - Evolução Anual'}
            category={sexes}
            values={values}
            subtitles={years}
            colors={colors}
        />
    );
};
